import { List } from 'react-admin';
import { GoogleAdsBridgesDataGrid } from './GoogleAdsBridgesDataGrid';
import { TablePagination } from '../../../helperComponents/TablePagination';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';
import { ToolBarRowStyleToggle } from '../../../helperComponents/ToolBarRowStyleToggle';
import { getGoogleAdsBridgesFilters } from './helpers/googleAdsBridgesFilters';

export const GoogleAdsBridgesList = (props) => {
  return (
    <>
      <TitleAboveTable title="Connected Accounts" />
      <List
        {...props}
        title=" "
        actions={<ToolBarRowStyleToggle showSelectColumnsButton showExportButton={false} />}
        pagination={<TablePagination />}
        filters={getGoogleAdsBridgesFilters()}
      >
        <GoogleAdsBridgesDataGrid />
      </List>
    </>
  );
};
